import {Badge} from "reactstrap";
import Utils from "../../common/Utils";
import React from "react";
import PropTypes from "prop-types";
import {css} from "glamor";
import _ from 'lodash';

const hoverStyle = css({
    cursor: "pointer",
    '&:hover':{
        backgroundColor: "#ebebeb"
    }
});

const textFieldStyle = css({
    overflowY: "auto",
    overflowWrap: "break-word",
    backgroundColor: "#5a5a5a0a"
});

export const TextField = ({ text , maxHeight = 148 }) => {

    return <div className={`${textFieldStyle} p-2`} style={{ maxHeight }}>
        {text}
    </div>
};

export const LevelBadge = ({ level , style }) => {

    let content;
    switch (level) {
        case "info":
            content = <Badge pill color="info">Information</Badge>;
            break;
        case "warn":
            content = <Badge pill color="warning">Warning</Badge>;
            break;
        case "error":
            content = <Badge pill color="danger">Error</Badge>;
            break;
        default:
            content = <Badge pill color="secondary">{Utils.ucFirst(level)}</Badge>;
            break;
    }

    return <h6 style={style}>{content}</h6>;
};

export const SectionedList = ({ items , defaultMode = "horizontal" }) => {

    return items.map((item,k) => (<React.Fragment key={k}>

        <div className={`${hoverStyle} p-1`}>
            {(item.mode || defaultMode) === "vertical" ? <div>
                {item.title && (<React.Fragment><b>{item.title}</b><br/></React.Fragment>)}
                {item.value}
            </div> : <span><b>{item.title}:</b> {item.value}</span>}
        </div>

        {(k !== items.length - 1) && <hr className="m-0"/>}

    </React.Fragment>));

};

export class ExpanderView extends React.Component{

    static propTypes = {
        title: PropTypes.any,
        isExpanded: PropTypes.bool,
        className: PropTypes.string,
        alignContent: PropTypes.bool,
        onExpand: PropTypes.func,
        onCollapse: PropTypes.func,
        method: PropTypes.oneOf([ 'collapse', 'hide' ])
    };

    static defaultProps = {
        alignContent: true,
        method: "collapse"
    };

    constructor(props){
        super(props);
        this.state = {
            isExpanded: props.isExpanded
        };
    }

    render(){

        const { isExpanded  } = this.state;
        const { title , className , alignContent , onExpand , onCollapse, method } = this.props;

        return <div className={className}>

            <div className={`p-1 ${hoverStyle}`} onClick={() => {

                this.setState({
                    isExpanded: !isExpanded
                }, () => {

                    if(this.state.isExpanded){

                        if(_.isFunction(onExpand)){
                            onExpand()
                        }

                    }
                    else{

                        if(_.isFunction(onCollapse)){
                            onCollapse();
                        }

                    }
                });

            }}>
                <span>
                    <i className={isExpanded ? "fa fa-chevron-up" : "fa fa-chevron-down"}/>
                    <h6 className="ml-2" style={{ display: "inline" }}>{title}</h6>
                </span>
            </div>
            {method === "collapse" ? (isExpanded ? <div className={alignContent ? "ml-4" : ""}>{this.props.children}</div>: null) : null}
            {method === "hide" ? (<div className={alignContent ? "ml-4" : ""} style={{ display: isExpanded ? undefined : "none" }}>{this.props.children}</div>) : null}
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/AuditExplorer/Elements.js